import 'react-select/dist/react-select.css';
import 'keen-slider/keen-slider.min.css';
import 'normalize.css/normalize.css';
import '../../src/index.css';

const IwStyleNormaliser = ({ children }) => {
    return children;
};

// eslint-disable-next-line import/no-default-export
export default IwStyleNormaliser;
